import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { IconChain, IconChainDashed, IconClose2 } from '../../svg'
import Modal from './index'

import HashList from '../../utils/hashlist'

import EditorMain from '../Editor/Editor.js'
import Toast from '../Toast'

class PersonalityOptions extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            initialDistribution: null,

            tmpProbabilityType: null,
            tmpProbability: null,

            activeQuestion: null,
            questions: [],

            activeOption: null,
            options: [],

            results: [],

            loading: true,
            saving: false,
        }
        this.base_state = this.state
    }

    async componentDidMount() {
        this._isMounted = true

        try {
            const { data } = this.props

            const distribution = await EditorMain.getEditedAppPersonalityDistribution()

            // Save initial
            await this.setState({
                initialDistribution: distribution.result,

                tmpProbability: distribution.result._probability,
                tmpProbabilityType: distribution.result._probabilityType,
            })

            const _questions = distribution.result.questions // QUESTION SCREENS
            const _options = distribution.result.options // ALL OPTIONS

            let questions = [] // QUESTIONS
            for (const question of _questions) {
                let obj = {
                    screenId: question.screenId,
                    options: _options.filter(option => option.screenId === question.screenId),
                    preview: {
                        bgColor: question.bgColor,
                        text: question.text,
                        image: question.image,
                    },
                }
                questions.push(obj)
            }

            const activeQuestionIndex__DEFAULT = 0
            let activeQuestionIndex__FINAL = activeQuestionIndex__DEFAULT
            let activeQuestion // ACTIVE QUESTION
            if (data.screen_id) {
                const activeQuestionIndex = questions.findIndex(question => question.screenId === data.screen_id)
                if (activeQuestionIndex !== -1) {
                    activeQuestionIndex__FINAL = activeQuestionIndex
                    activeQuestion = questions[activeQuestionIndex]
                } else {
                    activeQuestion = questions[activeQuestionIndex__DEFAULT]
                }
            } else {
                activeQuestion = questions[activeQuestionIndex__DEFAULT]
            }
            activeQuestion.index = activeQuestionIndex__FINAL

            // Save questions
            await this.setState({
                activeQuestion: activeQuestion,
                questions,
            })

            const activeOptionIndex__DEFAULT = 0
            let activeOptionIndex__FINAL = activeOptionIndex__DEFAULT
            let activeOption // ACTIVE OPTION
            if (data.option_id) {
                const activeOptionIndex = activeQuestion.options.findIndex(el => el.componentId === data.option_id)
                if (activeOptionIndex !== -1) {
                    activeOptionIndex__FINAL = activeOptionIndex
                    activeOption = activeQuestion.options[activeOptionIndex]
                } else {
                    activeOption = activeQuestion.options[activeOptionIndex__DEFAULT]
                }
            } else {
                activeOption = activeQuestion.options[activeOptionIndex__DEFAULT]
            }
            activeOption.index = activeOptionIndex__FINAL

            // Save options
            await this.setState({
                activeOption: activeOption,
                options: _options,
            })

            await this.refreshResults()

            await this.setState({
                loading: false,
            })
        } catch (err) {
            console.error(err)

            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        }
    }

    async refreshResults() {
        const {
            activeOption,
            initialDistribution: { results },
        } = this.state

        let updatedResults = [] // RESULTS FOR ACTIVE OPTION
        for (const result of results) {
            const link = activeOption.links.find(el => el.screenId === result.screenId)
            updatedResults.push({
                screenId: result.screenId,
                linked: link.weight !== 0,
                weight: link.weight,
                preview: {
                    bgColor: result.bgColor,
                    text: result.text,
                    image: result.image,
                },
            })
        }

        // Save results
        await this.setState({
            results: updatedResults,
        })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    handleClick__selectQuestion = screenId => async evt => {
        evt.preventDefault()

        try {
            const { questions } = this.state

            const activeQuestionIndex = questions.findIndex(question => question.screenId === screenId)
            const activeQuestion = {
                ...questions[activeQuestionIndex],
                index: activeQuestionIndex,
            }

            const activeOption = {
                ...activeQuestion.options[0],
                index: 0,
            }

            await this.setState({
                activeQuestion,
                activeOption,
            })

            await this.refreshResults()
        } catch (err) {
            console.error(err)

            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        }
    }
    handleClick__selectAnswer = componentId => async evt => {
        evt.preventDefault()

        try {
            const { options } = this.state

            const activeOptionIndex = options.findIndex(option => option.componentId === componentId)
            const activeOption = {
                ...options[activeOptionIndex],
                index: activeOptionIndex,
            }

            await this.setState({
                activeOption,
            })

            await this.refreshResults()
        } catch (err) {
            console.error(err)

            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        }
    }
    handleClick__createLink = (screenId, weight) => async evt => {
        evt.preventDefault()

        try {
            const { activeOption, options, activeQuestion, questions } = this.state

            let newLinks = activeOption.links.filter(link => link.screenId !== screenId)
            newLinks.push({
                screenId,
                weight,
            })

            const updatedActiveOption = {
                ...activeOption,
                links: newLinks,
                linked: newLinks.filter(link => link.weight > 0).length !== 0,
            }

            const activeOptionIndex__IN_OPTIONS = options.findIndex(
                option => option.componentId === activeOption.componentId,
            )

            let updatedOptions = options
            updatedOptions[activeOptionIndex__IN_OPTIONS].links = updatedActiveOption.links
            updatedOptions[activeOptionIndex__IN_OPTIONS].linked = updatedActiveOption.linked

            const activeOptionIndex__IN_QUESTION = activeQuestion.options.findIndex(
                item => item.componentId === updatedActiveOption.componentId,
            )
            let updatedActiveQuestion = activeQuestion
            updatedActiveQuestion.options[activeOptionIndex__IN_QUESTION].links = updatedActiveOption.links
            updatedActiveQuestion.options[activeOptionIndex__IN_QUESTION].linked = updatedActiveOption.linked

            const activeQuestionIndex = questions.findIndex(item => item.screenId === activeOption.screenId)
            const activeOptionIndex__IN_QUESTIONS = questions[activeQuestionIndex].options.findIndex(
                item => item.componentId === updatedActiveOption.componentId,
            )
            let updatedQuestions = questions
            updatedQuestions[activeQuestionIndex].options[activeOptionIndex__IN_QUESTIONS].links =
                updatedActiveOption.links
            updatedQuestions[activeQuestionIndex].options[activeOptionIndex__IN_QUESTIONS].linked =
                updatedActiveOption.linked

            await this.setState({
                activeOption: updatedActiveOption,
                options: updatedOptions,
                activeQuestion: updatedActiveQuestion,
                questions: updatedQuestions,
            })

            await this.refreshResults()
            await this.recalculateProbability()
        } catch (err) {
            console.error(err)

            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        }
    }

    recalculateProbability = async () => {
        const links = this.recalculateHashlist()

        const distribution = (await EditorMain.getEditedAppPersonalityDistribution(links, true)).result
        await this.setState({
            tmpProbability: distribution.probability,
            tmpProbabilityType: distribution.probabilityType,
        })
    }

    resetDistribution = async () => {
        try {
            const { activeOption, options, activeQuestion, questions, results } = this.state

            const newActiveOptionLinks = activeOption.links.map(link => {
                return {
                    ...link,
                    weight: 0,
                }
            })
            const newActiveOption = {
                ...activeOption,
                linked: false,
                links: newActiveOptionLinks,
            }

            const newOptions = options.map(option => {
                const links = option.links.map(link => {
                    return {
                        ...link,
                        weight: 0,
                    }
                })
                return {
                    ...option,
                    links,
                    linked: false,
                }
            })

            const newQuestions = questions.map(question => {
                return {
                    ...question,
                    options: newOptions.filter(option => option.screenId === question.screenId),
                }
            })

            const newActiveQuestionOptions = activeQuestion.options.map(option => {
                const links = option.links.map(link => {
                    return {
                        ...link,
                        weight: 0,
                    }
                })
                return {
                    ...option,
                    linked: false,
                    links,
                }
            })

            const newResults = results.map(result => {
                return {
                    ...result,
                    linked: false,
                    weight: 0,
                }
            })

            const distribution = (await EditorMain.getEditedAppPersonalityDistribution(new HashList([]), true)).result

            await this.setState({
                tmpProbability: distribution.probability,
                tmpProbabilityType: distribution.probabilityType,
                options: newOptions,
                questions: newQuestions,
                activeOption: newActiveOption,
                activeQuestion: {
                    ...activeQuestion,
                    options: newActiveQuestionOptions,
                },
                results: newResults,
            })

            Toast('success', {
                title: this.props.t('_common._notify._success.title'),
                title_only: true,
                time: 2000,
            })
        } catch (err) {
            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        }
    }

    recalculateHashlist = () => {
        try {
            const {
                options,
                initialDistribution: { results },
            } = this.state

            let newResults = []
            for (const result of results) {
                options.forEach(option => {
                    const i = option.links.findIndex(link => link.screenId === result.screenId)
                    const w = option.links[i].weight
                    if (w) {
                        newResults.push({
                            optionId: option.componentId,
                            resultId: result.screenId,
                            weight: option.links[i].weight,
                        })
                    }
                })
            }

            return new HashList(newResults)
        } catch (err) {
            console.error(err)

            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        }
    }

    handleClick__save = async evt => {
        evt.preventDefault()

        try {
            this.setState({
                saving: true,
            })

            const { events } = this.props

            const hashes = this.recalculateHashlist()

            EditorMain.setEditedAppData('app.personality.links', hashes)

            await events.init_save_silent()

            await events.updatePersonalityDistribution()

            events.on_close()
            Toast('success', {
                title: this.props.t('_common.saved'),
                title_only: true,
                time: 2000,
            })
        } catch (err) {
            console.error(err)
            Toast('error', {
                title: this.props.t('_common._notify._failed.title'),
                msg: this.props.t('_common._notify._failed.message'),
            })
        } finally {
            this.setState({
                saving: false,
            })
        }
    }

    onExited = async () => {}

    render() {
        const {
            saving,
            loading,
            tmpProbability,
            activeQuestion,
            questions,
            activeOption,
            options,
            results,
        } = this.state
        const { events, t } = this.props

        return (
            <Modal
                settings={{ overlay_close: false }}
                classes={{ overlay: '', modal: 'personality-style', closeButton: '', closeIcon: '' }}
                data={{ open: true, max_width: 960 }}
                events={{ onCloseModal: events.on_close, onExited: this.onExited }}
            >
                <div className="head">{t('_components._modal._personality_options.title')}</div>
                {loading ? (
                    <div className="local-loading">
                        <div className="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="wrap">
                            <div className="slides">
                                <div className="body">
                                    <ul>
                                        {questions.map((el, index) => {
                                            return (
                                                <li
                                                    className={
                                                        activeQuestion.screenId === el.screenId ? 'is-active' : ''
                                                    }
                                                    key={el.screenId}
                                                    onClick={this.handleClick__selectQuestion(el.screenId)}
                                                >
                                                    <div
                                                        className={`box${el.preview.image ? ' with-image' : ''}`}
                                                        title={el.preview.text}
                                                        style={{
                                                            backgroundImage: `url(${el.preview.image})`,
                                                            backgroundColor: el.preview.bgColor,
                                                        }}
                                                    >
                                                        <span>
                                                            {t('_components._modal._personality_options.q')}
                                                            {index + 1}
                                                        </span>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="answers left-divider">
                                <div className="body">
                                    <div className="title">
                                        {t('_components._modal._personality_options.answer_options')}
                                    </div>
                                    <div className="description">
                                        {t('_components._modal._personality_options.text_1')}
                                    </div>
                                    <div className="slide-preview">
                                        {/*<p>Question {activeQuestion.index + 1}</p>*/}
                                        <div
                                            className="img"
                                            style={{
                                                backgroundImage: `url(${activeQuestion.preview.image})`,
                                                backgroundColor: activeQuestion.preview.bgColor,
                                            }}
                                        >
                                            <span>{activeQuestion.preview.text}</span>
                                        </div>
                                        {/*{*/}
                                        {/*    activeQuestion.preview.image ? (*/}
                                        {/*        <div className="img" style={{ backgroundImage:  `url(${activeQuestion.preview.image})` }}>*/}
                                        {/*            <span>{activeQuestion.preview.text}</span>*/}
                                        {/*        </div>*/}
                                        {/*    ) : (<div className="text">{activeQuestion.preview.text}</div>)*/}
                                        {/*}*/}
                                    </div>
                                    <ul>
                                        {options
                                            .filter(el => el.screenId === activeQuestion.screenId)
                                            .map(el => {
                                                return (
                                                    <li
                                                        className={`${el.image ? 'img' : 'text'}${
                                                            activeOption.componentId === el.componentId
                                                                ? ' is-active'
                                                                : ''
                                                        }`}
                                                        key={el.componentId}
                                                        onClick={this.handleClick__selectAnswer(el.componentId)}
                                                    >
                                                        {el.image ? <img src={el.image} alt="" /> : el.text}

                                                        {el.linked ? (
                                                            <div className="linked">
                                                                <IconChain />
                                                            </div>
                                                        ) : null}
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                </div>
                            </div>
                            <div className="results left-divider">
                                <div className="body">
                                    <div className="title">
                                        {t('_components._modal._personality_options.result_pages')}
                                    </div>
                                    <div className="description">
                                        {t('_components._modal._personality_options.text_2')}
                                    </div>
                                    <ul>
                                        {results.map((el, index) => {
                                            return (
                                                <li key={el.screenId} className="with-probability">
                                                    <div
                                                        className="box"
                                                        style={{
                                                            backgroundImage: `url(${el.preview.image})`,
                                                            backgroundColor: el.preview.bgColor,
                                                        }}
                                                    >
                                                        <div>
                                                            {/*<span>R{index + 1}</span>*/}
                                                            <p>{el.preview.text}</p>
                                                        </div>
                                                    </div>

                                                    <div className="percentage">
                                                        {Math.round(tmpProbability[el.screenId].percentage)} %
                                                    </div>

                                                    {el.linked ? (
                                                        <>
                                                            {el.weight === 1 ? (
                                                                <div className="linked">
                                                                    <IconChainDashed />
                                                                </div>
                                                            ) : null}
                                                            {el.weight === 2 ? (
                                                                <div className="linked">
                                                                    <IconChain />
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    ) : null}

                                                    <ul className="actions">
                                                        {el.weight !== 1 ? (
                                                            <li onClick={this.handleClick__createLink(el.screenId, 1)}>
                                                                <div className="icon">
                                                                    <IconChainDashed />
                                                                </div>
                                                                <p>
                                                                    {t(
                                                                        '_components._modal._personality_options._link_type.weak',
                                                                    )}
                                                                </p>
                                                            </li>
                                                        ) : null}
                                                        {el.weight !== 2 ? (
                                                            <li onClick={this.handleClick__createLink(el.screenId, 2)}>
                                                                <div className="icon">
                                                                    <IconChain />
                                                                </div>
                                                                <p>
                                                                    {t(
                                                                        '_components._modal._personality_options._link_type.strong',
                                                                    )}
                                                                </p>
                                                            </li>
                                                        ) : null}

                                                        {el.linked ? (
                                                            <li
                                                                className="clear"
                                                                onClick={this.handleClick__createLink(el.screenId, 0)}
                                                            >
                                                                <div className="icon">
                                                                    <IconClose2 />
                                                                </div>
                                                                <p>
                                                                    {t(
                                                                        '_components._modal._personality_options._link_type.no_link',
                                                                    )}
                                                                </p>
                                                            </li>
                                                        ) : null}
                                                    </ul>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="buttons">
                            <div>
                                <span className="reset" onClick={this.resetDistribution}>
                                    {t('_components._modal._personality_options.reset_all_links')}
                                </span>
                            </div>
                            <div>
                                <button
                                    className="button"
                                    data-variant="secondary"
                                    data-size="lg"
                                    onClick={events.on_close}
                                >
                                    {t('Cancel')}
                                </button>
                                <button
                                    className="button"
                                    data-variant="primary"
                                    data-size="lg"
                                    disabled={saving}
                                    onClick={this.handleClick__save}
                                >
                                    {t('_common.save')}
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </Modal>
        )
    }
}

export default compose(connect(null, null), withTranslation('translations'))(PersonalityOptions)
